// extracted by mini-css-extract-plugin
module.exports = {"menu":"title_menu__IepNz"};